
import { Component, Emit, Vue, Prop } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { ChildComponentMixin } from '../mixins'
import AppCheckbox from '@/components/AppCheckbox.vue'
import AppContextMenu from '@/components/AppContextMenu.vue'
import { integrationModuleEntity } from '@/models/models'

@Component({
    components: {
        AppCheckbox,
        AppContextMenu,
        FontAwesomeIcon,
    },
})
export default class IntegrationsDraggableTableRow extends ChildComponentMixin {
    @Prop() private row!: IntegrationModuleEntity

    private contextMenuLeft: number = 0
    private contextMenuTop: number = 0
    private showContextMenu: boolean = false

    get isActive() {
        return this.row.status === 'ACTIVE'
    }

    get statusText() {
        return this.isActive ? 'Ativo' : 'Inativo'
    }

    get contextMenuOptions(): ContextMenuOptionEntity[] {
        const statusText = this.isActive ? 'Desativar' : 'Ativar'

        return [
            { value: 'edit', text: 'Editar', highlight: false },
            { value: 'status', text: statusText, highlight: false },
            { value: 'delete', text: 'Excluir', highlight: true },
        ]
    }

    public onClickMenu(element: any) {
        const position = element.currentTarget.getBoundingClientRect()

        this.contextMenuLeft = position.right + window.scrollX
        this.contextMenuTop = position.bottom + window.scrollY
        this.showContextMenu = true
    }

    public async onClickContextMenu(value: string) {
        this.showContextMenu = false

        switch (value) {
            case 'status':
                this.onChangeStatus()
                break
            case 'edit':
                this.onEditIntegrationModule()
                break
            case 'delete':
                this.onDeleteIntegrationModule()
                break
        }
    }

    public async onChangeSpotlight(isChecked: boolean) {
        const params = { id: this.row.id, isSpotlight: isChecked }

        const updated = await this.$store.dispatch('integration/updateIntegrationModule', params)

        if (updated) {
            this.row.isSpotlight = isChecked
        }
    }

    public async onChangeStatus() {
        const newStatus = this.isActive ? 'INACTIVE' : 'ACTIVE'
        const params = { id: this.row.id, status: newStatus }

        const updated = await this.$store.dispatch('integration/updateIntegrationModule', params)

        if (updated) {
            this.row.status = newStatus
        }
    }

    public onEditIntegrationModule() {
        this.$router.push(`/integrations/update/${this.row.id}`)
    }

    public  async onDeleteIntegrationModule() {
        const deleted = await this.$store.dispatch('integration/deleteIntegrationModule', this.row.id)

        if (deleted) {
            this.$emit('delete', this.row.id)
        }
    }
}
